import React, { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import api from "@/lib/api";

export default function TestimonialsSection() {
  const [testimonials, setTestimonials] = useState([]);
  const [content, setContent] = useState({});

  useEffect(() => {
    api.get("/testimonials").then((res) => setTestimonials(res.data)).catch(() => {});
    api.get("/site-settings").then((res) => setContent(res.data.homepage_content?.testimonials || {})).catch(() => {});
  }, []);

  if (testimonials.length === 0) return null;

  return (
    <section data-testid="testimonials-section" className="py-16 sm:py-20 bg-[#FDFCFB]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span data-testid="testimonials-overline" className="text-xs tracking-[0.2em] uppercase font-bold text-[var(--brand-primary)]">{content.overline || "Wall of Love"}</span>
          <h2 data-testid="testimonials-title" className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight text-[#1A1A1A] mt-3">{content.title || "What Our Customers Say"}</h2>
        </div>
        <Carousel opts={{ align: "start", loop: true }}>
          <CarouselContent>
            {testimonials.map((t, i) => (
              <CarouselItem key={i} className="md:basis-1/2 lg:basis-1/3" data-testid={`testimonial-item-${i}`}>
                <div className="p-6 rounded-lg border border-[#E5E1DA] bg-white h-full flex flex-col">
                  <Quote size={24} className="text-[var(--brand-primary)] mb-3" />
                  <p className="text-sm text-[var(--brand-secondary)] leading-relaxed flex-1">{t.text}</p>
                  <div className="flex items-center gap-1 mt-4">
                    {Array.from({ length: 5 }).map((_, j) => (
                      <Star key={j} size={14} fill={j < t.rating ? "var(--brand-primary)" : "none"} stroke="var(--brand-primary)" />
                    ))}
                  </div>
                  <p className="font-heading text-lg text-[#1A1A1A] mt-2">{t.name}</p>
                  <p className="text-xs text-[var(--brand-secondary)]">{t.location}</p>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious data-testid="testimonials-prev-btn" className="hidden sm:flex" />
          <CarouselNext data-testid="testimonials-next-btn" className="hidden sm:flex" />
        </Carousel>
      </div>
    </section>
  );
}
